module.exports = __webpack_public_path__ + "static/1-8dffdf77289bc42d552fa9d23c444d5d.png";